import React from 'react';
import { useScrollProgress } from '../hooks/useScrollProgress';
import './ScrollProgressBar.css';

const ScrollProgressBar = () => {
  const progress = useScrollProgress();
  return <div className="scroll-progress-bar" style={{ width: `${progress}%` }} />;
};

export default ScrollProgressBar;
